import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class SubscriptionStepperViewProvider {
	private readonly STEPPER_HEADER = 72;
	private readonly PANEL_HEADER = 48;
	private readonly DESCRIPTION = 43;
	private readonly GAP_PX = 93; // 32 + 24 + 16 + 16 + 5
	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const modalContent =
			elemRef.nativeElement.querySelector('.app-modal-content');

		const datablockList = elemRef.nativeElement.querySelector(
			'.subscription-datablock-list'
		);

		const columnsDatablockList = document.querySelector(
			'#columns-datablock .app-subscription-column-config'
		) as HTMLElement | null;

		const columnsConfigList = document.querySelector(
			'#columns-properties .app-subscription-column-config'
		) as HTMLElement | null;

		const listHeight =
			modalContent.offsetHeight -
			this.STEPPER_HEADER -
			this.PANEL_HEADER -
			this.DESCRIPTION -
			this.GAP_PX;

		renderer.setStyle(
			datablockList,
			'--max-height-datablocks',
			`${listHeight}px`,
			RendererStyleFlags2.DashCase
		);

		if (columnsDatablockList) {
			renderer.setStyle(
				columnsDatablockList,
				'--max-height-columns',
				`${listHeight}px`,
				RendererStyleFlags2.DashCase
			);
		}

		if (columnsConfigList) {
			renderer.setStyle(
				columnsConfigList,
				'--max-height-columns',
				`${listHeight}px`,
				RendererStyleFlags2.DashCase
			);
		}
	}
}
